import React from 'react';
import styled from 'styled-components';
import { Tooltip } from 'components/Tooltip';
import { Button } from 'components/Button';
import { buildCssProp, featureEnabled } from 'utils';
import { IListing } from '@bb/domain/dist/types';
import { AuthContextType } from 'contexts';
import { TOOLTIP_OPTIONS } from './constants';

type BookShowingButtonType = {
  isAutoConfirm: boolean;
  isDisabledBtns: boolean;
  listing: IListing & { id: string };
  isAgent: boolean;
  isListingAgent: boolean;
  isUnverified: boolean;
  org: AuthContextType['auth']['org'];
  handleBookModal: () => void;
};

export const BookShowingButton = ({
  isAutoConfirm,
  isDisabledBtns,
  listing,
  isAgent,
  isListingAgent,
  isUnverified,
  org,
  handleBookModal,
}: BookShowingButtonType) => (
    <Tooltip title={isDisabledBtns && TOOLTIP_OPTIONS.showing}>
      <span>
        <StyledBookShowingButton
          onClick={handleBookModal}
          type="primary"
          disabled={isDisabledBtns}
          $disabled={isDisabledBtns}
          data-cy="book-appointment"
        >
          {featureEnabled('preBookingNotificationFeature') ? (
            <>{isAutoConfirm ? 'Book Showing' : 'Request showing'}</>
          ) : (
            <a
              href={
                org &&
                org.features.includes('APPOINTMENT') &&
                !(isAgent && !isListingAgent && isUnverified)
                  ? `#/listing/${listing.id}/appointments/book`
                  : undefined
              }
            >
              {isAutoConfirm ? 'Book Showing' : 'Request showing'}
            </a>
          )}
        </StyledBookShowingButton>
      </span>
    </Tooltip>
  );

const StyledBookShowingButton = styled(Button)<{ $disabled: boolean }>`
  && {
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    border-radius: 7px;
    ${({ $disabled }) => buildCssProp('color', !$disabled && '#FFFFFF')}
  }
`;
